module.exports = __webpack_public_path__ + "static/media/login-load.cffa9d9d.gif";